import React, { useEffect, useState } from 'react';
import { CircularProgress, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import { CreateGameCard, GameCard } from '../../common/components';
import { getAllAdventures } from '../../common/services/adventuresRequest';

const useStyles = makeStyles((theme) => ({
	root: {},
	loaderContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		height: '100%',
	},
}));

const Home = () => {
	const classes = useStyles();
	const [adventures, setAdventures] = useState([]);
	const [loading, setLoading] = useState(true);

	const getAdventures = () => {
		getAllAdventures().then((adventures) => {
			setLoading(false);
			if (adventures) {
				setAdventures(adventures);
			}
		})
	}
	
	useEffect(() => {
		getAdventures()
	}, []);

	const defaultGameCard = {
		ID: '1',
		cover: '//upload.wikimedia.org/wikipedia/commons/thumb/b/be/Role_playing_gamers.jpg/800px-Role_playing_gamers.jpg',
		name: 'Boires',
		description: 'Partida por defecto para boires',
		isOwner: true,
		isMaster: true,
		isPlayer: true,
		link: '/game',
	};

	return (
		<Grid container spacing={2}>
			{loading ? (
				<Grid item xs={12}>
					<div className={classes.loaderContainer}>
						<CircularProgress />
					</div>
				</Grid>
			) : (
				<>
					{adventures.map((adventure) => (
						<Grid item xs={12} sm={6} md={4} lg={3} key={adventure.ID}>
							<GameCard adventure={adventure} refreshAdventures={getAdventures} />
						</Grid>
					))}
					<Grid item xs={12} sm={6} md={4} lg={3}>
						<CreateGameCard />
					</Grid>
				</>
			)}
		</Grid>
	);
};

export default Home;
